import { Box, Typography, useTheme } from "@mui/material";

type LegendItem = {
    color: string;
    label: string;
};

type LegendProps = {
    items: LegendItem[];
};

export const Legend = (props: LegendProps) => {
    const { items } = props;
    const theme = useTheme();

    return (
        <Box
            gap={theme.spacing(4)}
            alignItems="left"
            justifyContent="left"
            sx={{
                display: "flex",
                p: theme.spacing(4),
                maxWidth: "100%",
                overflow: "none",
                flexWrap: "wrap",
            }}
        >
            {items.map((item, index) => (
                <Box
                    key={index}
                    display="inline-flex"
                    alignItems="center"
                    justifyContent="left"
                    gap={theme.spacing(1.5)}
                >
                    <Box
                        sx={{
                            minWidth: theme.spacing(2),
                            minHeight: theme.spacing(2),
                            borderRadius: theme.spacing(0.5),
                            backgroundColor: item.color,
                        }}
                    />
                    <Typography variant="body-bold" color="text.secondary">
                        {item.label}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
};

export default Legend;
